
	import {  BaseTLTableComponent, AxiosResponse, ObjectTypesHelper, BaseTLTableBase, Watch, tlISODateToLocalString, tlISODateTimeToLocalNoSecondsString } from "../../../Infrastructure/CorBase/CoreBase";
	import { ContentService, ContentFilter } from "../../../Services/ContBase/AllConServices";

	export default abstract class ContentListBase extends BaseTLTableComponent {
	
		selectedContentId: number = 0;
		contentService: ContentService = new ContentService();
		objectType: ObjectTypesHelper.ObjectTypeEnum = ObjectTypesHelper.ObjectTypeEnum.Content;


		//co se zobrazni kdyz je prvek vybraný - lze vice sloupců
		names = ['name'];

		changeTagsBase(items: any, idLast: number) {
			var tagsItem = (this.tableData as Array<any>).filter(c => c.id == idLast)[0];
			tagsItem.tags = items;
		}

		goBackDetailModalBase(item: any, tableData: Array<any>): void {
			for (var i = 0; i < tableData.length; i++) {
				var changeItem = (tableData[i].tags as Array<any>).filter((c: any) => c.id == item.id);
				if (changeItem.length > 0) {
					changeItem[0].name = item.name;
					changeItem[0].color = item.color;
				}
			}
		}

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: ContentFilter = new ContentFilter(this.$store.state.idTenant, false);
		  return this.contentService.getAllByFilter(filter);
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
        }

		refreshItems(items: any[], refreshData: any[]) {
			return items;
        }

		selectRowsBase(items: any) {
			super.selectRows(items);
		}

		prepareItems(items: any[]) {		
			// zde zatim nepotrebujeme
		}

		
		showAllertToDeleteClickBase(itemsSelected: any) {
			this.itemsSelected = itemsSelected;
			this.showAlertModalById('alertModalIdAllow');
		}

		deleteSelected() {
			if (this.itemsSelected) {
				// VaPTODO - schovavame dialog, ktery vytvori base-tl-table, na zaklade jeho identifikatoru a pritom ani nevime, zda byl otevreny a ze se stale jmenuje stejne... a to neni dobre
				this.$bvModal.hide('popupDialog');
				this.isBusy = true;
				this.deleteItemsList = this.getSelectedList();
				super.deleteList();
			}

			//TODO co se nesmazalo by melo zůstat
			(this.$refs.contentsTable as BaseTLTableBase).clearSelected();
		}

		protected deleteListServer(): Promise<AxiosResponse<any>> {
			return this.contentService.deleteList(this.deleteItemsList);
		}


		setFields() {
			this.fields = [
				//{ key: 'id', label: 'id', sortable: true, class: 'text-center helpWidth150' },
				{ key: 'image', label: this.$t('content.fieldImage'), sortable: false, class: 'text-left columnImage', design: 'popupImage', trans: 'content.fieldImage' },
				{ key: 'name', label: this.$t('content.fieldName'), sortable: true, class: 'text-left', design: 'detail', trans: 'content.fieldName' },
				{ key: 'idContentTypeNavigationName', label: this.$t('content.fieldType'), sortable: true, class: 'text-left helpWidth180', trans: 'content.fieldType', design: 'useIcon' },
				{ key: 'firstTaskName', label: this.$t('content.fieldTask'), sortable: false, class: 'text-left', tooltip: 'allTasksNameHtml', design: 'link_task', optional: true, visible: true, trans: 'content.fieldTask' },
				{ key: 'tags', label: this.$t('content.fieldTags'), trans: 'content.fieldTags', sortable: false, class: 'text-left', design: 'tags', action: 'filter', tooltip: 'tags' },

				{ key: 'idContentVariantParameters', label: this.$t('content.fieldParam'), sortable: false, class: 'text-left', optional: true, visible: true, design: 'columnBackGround', trans: 'content.fieldParam' },
				{ key: 'idContentVariantFileSize', label: this.$t('content.fieldFileSize'), sortable: true, class: 'text-left', optional: true, visible: false, trans: 'content.fieldFileSize' },
				{ key: 'idContentVariantLength', label: this.$t('content.fieldLength'), trans: 'content.fieldLength', sortable: true, class: 'text-left', optional: true, visible: false },
				{ key: 'idContentVariantTransocerParameterResolution', trans: 'content.fieldResolution', label: this.$t('content.fieldResolution'), sortable: false, class: 'text-left', optional: true, visible: false },
				{ key: 'url', label: this.$t('content.fieldUrl'), trans: 'content.fieldUrl', sortable: true, class: 'text-left', optional: true, visible: false },
				//tohle tam musi být i neviditelné
				{ key: 'idContentTypeIdentifier', label: 'Neviditelny', sortable: false, class: 'text-left', optional: true, visible: false, show: false },
				{ key: 'creationDate', label: this.$t('content.fieldCreated'), trans: 'content.fieldCreated', sortable: true, class: 'text-left', visible: false, optional: true, formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
				{ key: 'whenChanged', label: this.$t('content.fieldChanged'), trans: 'content.fieldChanged', sortable: true, class: 'text-left', visible: false, optional: true, formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },

				//kdyz chci filtr i pro neviditelny sloupec tak pouzit u filtru showAnyTime
				{ key: 'allTasksName', label: 'Neviditelny x', sortable: false, class: 'text-left', optional: false, visible: false, show: false },
				{ key: 'actions', label: this.$t('content.fieldActions'), trans: 'content.fieldActions', class: 'text-right', thClass: 'lastColumnTable' }
			];

			this.gridFields = [
				{ key: 'design', design: 'GridMedia', label: 'Typ gridu co se zobrazi' },
				{ key: 'description1', data: 'gridDescription1', label: this.$t('receiver.fieldDescription'), trans: 'receiver.fieldDescription', sortable: true },
				{ key: 'firstTaskName', data: 'firstTaskName', label: this.$t('content.fieldTask'), trans: 'content.fieldTask', sortable: false },
				{ key: 'description2', data: 'gridDescription2' },
				{ key: 'name', data: 'name', sortable: true, label: this.$t('content.fieldName'), trans: 'content.fieldName' },
				{ key: 'idTask', data: 'id', sortable: false },
				{ key: 'nameTask', data: 'allTasksName', sortable: false },
				{ key: 'taskList', data: 'allTasksNameHtml', sortable: false },
				{ key: 'typeFile', data: 'idContentTypeIdentifier', sortable: true, label: this.$t('content.fieldType'), trans: 'content.fieldType' },
				{ key: 'image', data: 'image', sortable: false },

				{ key: 'idContentTypeNavigationName', data: 'idContentTypeNavigationName', sortable: false, label: 'Typ' },
				{ key: 'idContentVariantParameters', data: 'idContentVariantParameters', sortable: false, label: 'Parametry média' },

				{ key: 'idContentVariantFileSize', data: 'idContentVariantFileSize', sortable: false, label: 'Velikost originálu' },
				{ key: 'url', data: 'url', sortable: false, label: 'Url' },
				{ key: 'tags', data: 'tags', action: 'filter' },
			];
		};

		//filtry
		setfilters(value: any) {
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else if (value != null) {
				var filtersValue = value as Array<any>;				
				for (var i = 0; i < this.filters.length; i++) {
					if (this.filters[i].trans != undefined) {
						this.filters[i].label = this.$t(this.filters[i].trans);
						this.filters[i].selected = filtersValue.filter((c: any) => c.key == this.filters[i].key)[0].selected;
						this.filters[i].value = filtersValue.filter((c: any) => c.key == this.filters[i].key)[0].value;
					}
				}
			}
			else {
				this.langInit = this.$store.state.currentLanguage;
				this.filters = [
					{ key: 'name', label: this.$t('content.filterName'), trans: 'content.filterName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
					{ key: 'allTasksName', label: this.$t('content.filterTask'), trans: 'content.filterTask', selected: false, value: null, type: 'text', showAnyTime: true },				
					{ key: 'tags', label: this.$t('content.filterTag'), trans: 'content.filterTag', selected: false, value: null, type: 'multi', multiselect: true },
				];
				//skupinový filtr
				var componentGroup = { key: 'ENU_CON_Content_Type', label: 'AAA doplnit', selected: true, value: 'AAA doplnit', type: 'text', group: true, groupId: 'idContentTypeIdentifier', groupName: this.$t('global.filterNotShowType').toString(), headName: this.$t('content.filterGroupName'), trans: 'content.filterGroupName', isNegative: true };
				super.loadFiltersEnum(componentGroup);
			}
		}

		//all task name task !!! zmeni

		//@ts-ignore
		@Watch('$store.state.currentLanguage')
		changeFieldsAfterChangeLanguageD(value: boolean, oldValue: boolean) {
			this.setfilters(null);
		}

	};